import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useSelector } from 'react-redux';
import { RootState } from '../../configuration';
import { DonateGoalContent } from './donate-goal-content';

export const DonateGoalPage: React.FC = () => {
  const profile = useSelector(
    (state: RootState) => state.features.auth.profile
  );

  return (
    <div className="w-full max-w-5xl mx-auto px-4 py-5 bg-white dark:bg-dark2 min-h-screen">
      <Helmet>
        <title>Mục tiêu Donate - Cab</title>
      </Helmet>
      <DonateGoalContent profile={profile} />
    </div>
  );
};

export default DonateGoalPage;
